<template>
   <validation-modal ref="validationModal" :titleText="$t('message.transactionRefundDialog.title')"
      @refresh="$emit('refresh')" :adjustParameters="adjustParameters" :before-submit-judgement="amountJudgment" :default-function="postRefundAmount"
      :validation-condition="refundCondition">
      <div class="modal-info" slot="prefix">
        <i class="el-icon-info" style="margin-right: 10px;"></i>
        <span>{{ $t('message.transactionRefundDialog.info') }}</span>
      </div>
      <div v-if="detailData?.refundStatus === '2'" class="remainingAmountTips">{{ $t('message.transactionRefundDialog.remainingAmountTips', { amount: detailData?.refundAmount?.amount, currency: detailData?.refundAmount?.currency }) }}</div>
      <div class="modal-info subscription-radio" v-if="!['canceled', 'ended', null].includes(detailData?.subscriptionStatus)">
        <div class="subscription-radio-title">{{ $t('message.transactionRefundDialog.subscriptionRelated') }}
          <el-popover placement="right" :width="100" popper-class="popper-dark" trigger="hover">
            <div v-html="$t('message.transactionRefundDialog.subscriptionRelatedTips')"></div>
            <template #reference>
              <img style="width:16px;height:16px;cursor:pointer;margin-left: 8px;"
                src="@/assets/images/base/icon-note.png" />
            </template>
          </el-popover>
        </div>
        <el-radio-group class="subscription-radio-group" v-model="subscriptionRadio">
          <el-radio :label="1">
            <span>{{ $t('message.transactionRefundDialog.refundOnly') }}</span>
          </el-radio>
          <el-radio :label="2">
            <span>{{ $t('message.transactionRefundDialog.refundAndUnsubscribe') }}</span>
          </el-radio>
        </el-radio-group>
      </div>
    </validation-modal>
</template>

<script>
import ValidationModal from '@/components/modal/base-modal/validation-modal.vue';
import { ShowWarningMessage, ShowSuccessMessage, ShowErrorMessage } from '@/components/modal/tips/message-tips';
import { REQUIRED } from '@/components/validation/tool/validator';
import TransitionService from '@/views/transaction/api/transaction-query.service';

export default {
  name: 'RefundDialog',
  components: {
    ValidationModal,
  },
  data() {
    return {
      ...TransitionService,
      detailData: undefined,
      dialogVisible: false,
      // 1: 仅退款，2: 退款并取消订阅
      subscriptionRadio: 1,
      refundCondition: [
        {
          key: 'amount',
          name: 'message.transaction.requestRefundAmount',
          type: 'editinput',
          defValue: '',
          isShowStar: true,
          rule: [REQUIRED],
        },
      ],
      extraParams: {},
    };
  },
  methods: {
    async open(txnId) {
      this.extraParams = {};
      await this.fetchDetail(txnId);

      await this.$refs.validationModal.openModal();
      this.initData();
      this.extraParams = { ...this.extraParams, ids: [txnId] };
    },
    async fetchDetail(id) {
      this.detailData = await this.getTransactionDetails(id);
    },
    initData() {
      this.subscriptionRadio = 1;
      const { refundAmount } = this.detailData;
      if (refundAmount && refundAmount.amount) {
        this.$refs.validationModal.getForm().assignmentFormValue({ amount: refundAmount.amount });
      }
    },
    amountJudgment(params) {
      if (!this.detailData || !this.detailData.refundAmount || +this.detailData.refundAmount.amount - +params.amount < 0) {
        ShowWarningMessage(this.$t('message.transaction.maximumRefundAmount') + this.detailData.refundAmount.amount);
        return false;
      }
      if (this.detailData.refundAmount.currency === 'JPY' && (params.amount && +params.amount % 1 !== 0)) {
        ShowWarningMessage(this.$t('message.transaction.refundAmountInt'));
        return false;
      }

      return true;
    },
    adjustParameters(params) {
      if (this.subscriptionRadio === 2) {
        this.extraParams = { ...this.extraParams, txnResultThen: 'CANCEL_SUBSCRIPTION_IF_REFUND_SUCCESS' };
      }
      return { ...params, ...this.extraParams };
    },

  },
};
</script>

<style lang="scss" scoped>
.modal-info {
  margin-bottom: 20px;
  color: #0C99CD;
}

.subscription-radio {
  height: 108px;
  padding: 24px;
  background: #F9FAFB;
  border-radius: 8px;
}

.subscription-radio-title {
  font-family: Open Sans, Open Sans;
  font-weight: bold;
  font-size: 16px;
  color: #1A202C;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 25px;
  display: flex;
  align-self: center;
}

.subscription-radio-group {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.remainingAmountTips {
  margin-top: -12px;
  margin-bottom: 24px;
  font-family: Open Sans, Open Sans;
  font-weight: 400;
  font-size: 12px;
  color: #667085;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
</style>
